import { render } from "./DisapprovedSvg.vue?vue&type=template&id=d2d8bf0e"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__